import { Component, inject, OnInit, Inject, Optional, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DynamicFormsV2Component } from '../../shared/dynamic-forms-v2/dynamic-forms-v2.component';
import { FormFieldsSelectDataService } from '../../shared/form-fields-select-data.service';
import { ErrorService } from '../../shared/error.service';
import { HttpClient } from '@angular/common/http';
import { forkJoin, map, of, Observable, switchMap, catchError } from 'rxjs';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatExpansionModule } from '@angular/material/expansion';
import { FormFields, formMetaData, IndividualField } from '../../shared/dynamic-forms.interface2';
import { UtilityService } from '../../shared/utility.service';
import { FhirResourceService } from '../../shared/fhir-resource.service';
import { SuccessMessageComponent } from '../../shared/success-message/success-message.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { backendEndPointToken, hardCodedHospitalId } from '../../app.config';
import { CodeableConcept, Medication, MedicationDispense, Reference, ChargeItem, ChargeItemDefinition, Invoice, BundleEntry } from 'fhir/r4';
import { CodeableConcept2Pipe } from "../../shared/codeable-concept2.pipe";
import { NaPipe } from "../../shared/na.pipe";
import { ReferenceDisplayDirective } from '../../shared/reference-display.directive';
import { Form, FormArray, FormBuilder, AbstractControl, FormGroup } from '@angular/forms';
import { MedicationDispenseFieldFilterService } from '../medication-dispense-field-filter.service';
import { FhirResourceTransformService } from '../../shared/fhir-resource-transform.service';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Dosage, MedicationRequest } from 'fhir/r4';
import { StateService } from '../../shared/state.service';
import { AuthService } from '../../shared/auth/auth.service';
import { FirebaseAlertService } from '../../shared/services/firebase-alert.service';

@Component({
    selector: 'app-add-medication-dispense',
    standalone: true,
    imports: [
        CommonModule,
        ReferenceDisplayDirective,
        MatCardModule,
        MatButtonModule,
        MatIconModule,
        MatTooltipModule,
        DynamicFormsV2Component,
        CodeableConcept2Pipe,
        NaPipe
    ],
    templateUrl: './add-medication-dispense.component.html',
    styleUrls: ['./add-medication-dispense.component.scss']
})
export class AddMedicationDispenseComponent implements OnInit {
    dialogRef = inject(MatDialogRef<AddMedicationDispenseComponent>);
    formFieldService = inject(FormFieldsSelectDataService);
    errorService = inject(ErrorService);
    http = inject(HttpClient);
    utilityService = inject(UtilityService);
    fhirResourceService = inject(FhirResourceService);
    snackBar = inject(MatSnackBar);
    backendEndPoint = inject(backendEndPointToken);
    private auth = inject(AuthService);
    private firebaseAlertService = inject(FirebaseAlertService);
    formFields: (FormFields[])[] = [];
    fb = inject(FormBuilder);
    substitutionForm = this.fb.group({
        substitutionArray: this.fb.array([])
    });
    substitutionFormArray = this.substitutionForm.get('substitutionArray') as FormArray;

    addToSubstitutionArray(
        values?: { authorizingPrescription?: string; wasSubstituted?: string; reason?: string; type?: string }
    ) {
        this.substitutionFormArray.push(this.fb.group({
            authorizingPrescription: [''],
            wasSubstituted: [''],
            reason: [''],
            type: ['']
        }));

        const lastIndex = this.substitutionFormArray.length - 1;
        if (values) {
            this.substitutionFormArray.at(lastIndex).patchValue({
                authorizingPrescription: values.authorizingPrescription || '',
                wasSubstituted: values.wasSubstituted || '',
                reason: values.reason || '',
                type: values.type || ''
            });
        }
    }
    newMedicationCodeableConcept: { [key: string]: CodeableConcept | null } = {}
    newMedicationReference: { [key: string]: Reference | null } = {}
    medicationDispenseFieldFilterService = inject(MedicationDispenseFieldFilterService);
    dialog = inject(MatDialog)
    fhirResourceTransformService = inject(FhirResourceTransformService);
    openSubstitutionForm(medicationRequestId: string) {

        const formFields = [
            ...this.medicationDispenseFieldFilterService.filterFormFields([...this.formFields[0]], ['medicationReference']),
            ...this.medicationDispenseFieldFilterService.filterFormFields([...this.formFields[0]], ['substitution']),


        ];
        const df = this.dialog.open(DynamicFormsV2Component, {
            maxHeight: '93vh',
            data: {
                formFields: formFields,
                formMetaData: <formMetaData>{
                    formName: 'Medication Substitution',
                    formDescription: 'Provide details for medication substitution.',
                    submitText: 'Submit',
                    closeDialogOnSubmit: true,

                }

            }
        });

        df.afterClosed().subscribe((e: any) => {
// $#$            // /* alert(JSON.stringify(e.values) */)
            if (e.values) {

                this.searchAndUpdateControlsInSubstitutionArray({
                    authorizingPrescription: medicationRequestId
                }, {
                    newValue: {
                        wasSubstituted: true, type: this.fhirResourceTransformService.toCodeableConcept(e.values.substitution.substitution_type),
                        reason: this.fhirResourceTransformService.toCodeableConcept(e.values.substitution.substitution_reason)
                    }
                });
                if (e.values.medicationReference) {
                    this.newMedicationReference[medicationRequestId || ''] = this.fhirResourceTransformService.toReference(e.values.medicationReference);
                    this.searchAndUpdateControlsInSubstitutionArray({
                        authorizingPrescription: medicationRequestId
                    }, {
                        newValue: {
                            medicationReference: this.fhirResourceTransformService.toReference(e.values.medicationReference)
                        }
                    }, this.MedicationReferenceArray);
                }
                this.putTogether();
            }

        })


    }
    medicationReferenceFallBackForm = this.fb.group({
        medicationReferenceArray: this.fb.array([])
    });
    //addtit
    get MedicationReferenceArray() {
        return this.medicationReferenceFallBackForm.get('medicationReferenceArray') as FormArray;
    }
    combinedResource: any[] = [];
    addToMedicationReferenceArray(value: { authorizingPrescription?: string, medicationReference?: Reference }) {
        this.MedicationReferenceArray.push(this.fb.group({
            medicationReference: [value.medicationReference || null],
            authorizingPrescription: [value.authorizingPrescription || '']
        }));
    }

    reverseSubstitution(medicationRequestId: string) {
        const updatedCount = this.searchAndUpdateControlsInSubstitutionArray({
            authorizingPrescription: medicationRequestId
        }, {
            newValue: {
                wasSubstituted: false, type: undefined,
                reason: undefined
            }
        });
        this.newMedicationReference[medicationRequestId || ''] = null;
        this.searchAndUpdateControlsInSubstitutionArray({
            authorizingPrescription: medicationRequestId
        }, {
            newValue: {
                medicationReference: ""
            }
        }, this.MedicationReferenceArray);
        //get cmbined resurces BEFRE and after
        const medicationRefFromCombinedResourcesBefore = this.combinedResource.find(r => (r.authorizingPrescription ?? [])[0].reference === `MedicationRequest/${medicationRequestId}`).medicationReference;
// $#$        // /* alert('medicationRefFromCombinedResourcesBefore reverseSubstitution: ' + JSON.stringify(medicationRefFromCombinedResourcesBefore) */);
        this.putTogether();
        //after
        const medicationRefFromCombinedResourcesAfter = this.combinedResource.find(r => (r.authorizingPrescription ?? [])[0].reference === `MedicationRequest/${medicationRequestId}`).medicationReference;
        this.getDispensableUnitsForMedicationReference()
// $#$        // /* alert('medicationRefFromCombinedResourcesAfter reverseSubstitution: ' + JSON.stringify(medicationRefFromCombinedResourcesAfter) */);

    }
    searchAndUpdateControlsInSubstitutionArray(
        searchObject: { [key: string]: string },
        options: {
            newValue?: unknown;
            updater?: (control: AbstractControl, key: string, group: FormGroup) => void;
        } = {},
        form: FormArray = this.substitutionFormArray
    ): any {
        const normalizedSearch = !!searchObject
        if (!normalizedSearch) return 0;
        const targetArray = form;
        if (!targetArray?.length) return 0;

        let updatedVal: any = null;
        targetArray.controls.forEach(control => {
            // const isThis: boolean = false;
            if (!(control instanceof FormGroup)) return;
            Object.entries(control.controls).forEach(([key, child]) => {
                if (!key || !child) return;
                const keyFound = Object.keys(searchObject).find(k => key.toLowerCase() === k.toLowerCase());
                const valueFound = keyFound ? searchObject[keyFound] === child.value : undefined;
                if (valueFound) {
// $#$                    // /* alert('found'); */



                    // updatedCount++;
                    if (options.updater) {
                        options.updater(child, key, control);
                    } else if (options.newValue !== undefined && 'setValue' in child) {
// $#$                        // /* alert(JSON.stringify(options.newValue) */);
                        if (options.newValue) {
                            control.patchValue(options.newValue || {});

                        }

                    }
                    child.markAsTouched();
                    child.markAsDirty();
                    updatedVal = { ...control.value, ...(options?.newValue || {}) };


                }
            });
        });
        delete updatedVal?.authorizingPrescription;
// $#$        // /* alert(JSON.stringify(updatedVal) */)
        return updatedVal;
    }

    medicationRequestId: (string | null)[] = [];
    private authorizingRequests: MedicationRequest[] = [];

    formMetaData = {
        formName: 'Medication Dispense',
        formDescription: 'Use this form to record a medication dispense.',
        submitText: 'Submit Dispense'
    };
    medicationRefenceFormField: FormFields[][] | null[] = [null];
    remainingDispenseFormFields: FormFields[][] = [];
    medRequestEncounters: Record<string, MedicationRequest['encounter']> = {};
    ngOnInit() {
        this.MedicationReferenceArray.valueChanges.subscribe(val => {
// $#$            // /* alert(JSON.stringify(val) */);
            this.getDispensableUnitsForMedicationReference(val);
        });
        if (!this.data.groupId) {
            this.medicationRefenceFormField[0] = this.medicationDispenseFieldFilterService.filterFormFields([...this.formFields[0]], ['medicationReference']);
            this.remainingDispenseFormFields[0] = this.medicationDispenseFieldFilterService.removeFormFields([...this.formFields[0]], ['medicationReference', 'substitution', 'medicationCodeableConcept']);
            this.addToMedicationReferenceArray({ authorizingPrescription: this.data.medicationRequestId, medicationReference: this.data.medicationReference ?? '' });


            const mr: MedicationRequest | null = (this.data?.row as MedicationRequest) ?? null;
            this.medRequestEncounters = { ...(mr?.encounter ? { [`MedicationRequest/${mr.id}` || '']: mr.encounter } : {}) };
            const dosage = Array.isArray(mr?.dosageInstruction) ? (mr!.dosageInstruction as Dosage[]) : [];

            if (dosage.length) {
                this.medRequestDosageJson = [dosage];
                this.medRequestDosageText = [this.formatMedicationRequestDosage(dosage)];
            }
            if (mr) {
                this.authorizingRequests = [mr];
            }
        }

        const rawIsPaid = this.data?.isPaid;
        this.isPaid = typeof rawIsPaid === 'boolean' ? rawIsPaid : null;
        this.showPaymentNotice = this.isPaid !== true;


    }
    isPaid: boolean | null = null;
    showPaymentNotice: boolean = true
    @ViewChild('mrF') medicationReferenceFormComponent!: DynamicFormsV2Component;
    //#rf
    @ViewChild('rf') remainingDispenseFormComponent!: DynamicFormsV2Component;
    ngAfterViewInit() {
        this.remainingDispenseFormComponent?.aForm.valueChanges.subscribe((val: any) => {
            this.putTogether();
        });
        this.medicationReferenceFormComponent?.aForm.valueChanges.subscribe((val: any) => {
            this.putTogether();
        });
        if (!this.data.groupId) {

            this.medicationReferenceFormComponent?.aForm?.get(['medicationReference'])?.valueChanges.subscribe((val: any) => {

// $#$                // /* alert(JSON.stringify(this.fhirResourceTransformService.toReference(val) */))
                this.searchAndUpdateControlsInSubstitutionArray({
                    authorizingPrescription: this.medicationRequestId[0] || ''
                }, {
                    newValue: {
                        medicationReference: this.fhirResourceTransformService.toReference(val)
                    }
                }, this.MedicationReferenceArray);
            })
        }
    }
    medicationCodeableConcept: CodeableConcept[] | null[] = [null];
    medicationReference: Reference[] | null[] = [null];
    subject: Reference[] | null[] = [null];
    groupId: string | null = null;



    putTogether() {
        this.combinedResource = [];
        for (let i = 0; i < this.formFields.length; i++) {
            //medRef can be from fallback form if med.req opened without groupId
            // const medRef = this.MedicationReferenceArray.at(i)?.get('medicationReference')?.value || this.medicationReference[i] || null;
            let medRef = this.searchAndUpdateControlsInSubstitutionArray({ authorizingPrescription: this.medicationRequestId[i] || '' }, {}, this.MedicationReferenceArray);
            medRef = medRef?.medicationReference || this.medicationReference[i] || null;
// $#$            // /* alert('medRef for index ' + i + ' is ' + JSON.stringify(medRef) */);
            const substitutionInfo = this.searchAndUpdateControlsInSubstitutionArray({ authorizingPrescription: this.medicationRequestId[i] || '' }, {},
                this.substitutionFormArray
            );

            //get the medicine dispensabe units


            const dosageInstruction = this.utilityService.constructDosageTypeObject(this.remainingDispenseFormComponent.aForm.value) ? [this.utilityService.constructDosageTypeObject(this.remainingDispenseFormComponent.aForm.value)!] : [];
// $#$            // /* alert(JSON.stringify(dosageInstruction) */)
            this.combinedResource.push({
                // medicationCodeableConcept: this.medicationCodeableConcept[i] || null,
                medicationReference: medRef,
                substitution: substitutionInfo,
                authorizingPrescription: [this.medicationRequestId[i]],
                ...this.fhirResourceTransformService.transformValues('MedicationDispense', this.remainingDispenseFormComponent.aForm.value),
                performer: [{
                    actor: this.fhirResourceTransformService.toReference(this.remainingDispenseFormComponent.aForm?.value?.performerActor)
                }],

                whenHandedOver: this.remainingDispenseFormComponent.aForm?.value?.['whenHandedOver'] || new Date().toISOString(),
                quantity: { value: this.remainingDispenseFormComponent.aForm?.value?.quantity || null },
                ...(dosageInstruction.length ? { dosageInstruction } : {})
                // receiver: this.fhirResourceTransformService.toReferenceArray(this.remainingDispenseFormComponent.aForm?.value?.receiver)
                // groupId: this.groupId,
                // formFields: this.formFields[i],
                // medicationRequestId: this.medicationRequestId[i] || null
            });
            if (dosageInstruction.length === 0) {
                delete this.combinedResource[i].dosageInstruction;
            }
            // no category? delete it
            if (!this.combinedResource[i]?.category || Object.keys(this.combinedResource[i]?.category || {}).length === 0) {
                delete this.combinedResource[i].category;
            }
            //delete dosageTimng and doseAndRateDoseQuantity
            delete this.combinedResource[i]['dosageTiming'];
            delete this.combinedResource[i]['doseAndRateDoseQuantity'];


            //delete raw form values.

            if (this.combinedResource[i].substitution === null
                || !this.combinedResource[i]?.substitution?.wasSubstituted) {
                delete this.combinedResource[i].substitution;
            }
            delete this.combinedResource[i].performerActor;
            delete this.combinedResource[i]['dosageInstruction.text'];
            // if (this.combinedResource[i]?.dosageInstruction?.text === undefined) {
            //     delete this.combinedResource[i].dosageInstruction;
            // }
            // if receiver is empty, add subject
            if (!this.combinedResource[i]?.receiver || this.combinedResource[i]?.receiver?.length === 0
                || (this.combinedResource[i]?.receiver[0] === '' && this.combinedResource[i]?.receiver.length === 1)

            ) {
                this.combinedResource[i].receiver = [this.combinedResource[i].subject];
            }

        }
    }

    dispensabeUnits: { [key: string]: string | null } = {}
    getDispensableUnitsForMedicationReference(formArrayValue: any[] | null = null): void {
// $#$        // /* alert('getting dispensable units for ' + JSON.stringify(medRef) */);
        let toUse = formArrayValue || this.combinedResource;
        toUse.forEach((medRefObj, idx) => {
            const medRef: Reference = medRefObj.medicationReference ?? this.medicationReference[idx];
            if (!medRef || !medRef.reference) return;
            if (this.dispensabeUnits[medRef.reference]) {
                this.stampIt(this.dispensabeUnits[medRef.reference], idx);
                return;
            }


            this.http.get<Medication>(`${this.backendEndPoint}/Medication/${medRef.reference?.split("/")[1]}`).pipe(
                map((medication: Medication) => {

                    // ],
                    const dispensableUnitsExtension = medication.extension?.find(ext => ext.url.includes('dispensableUnits'));
                    let dU = dispensableUnitsExtension ? dispensableUnitsExtension.valueString || null : null;
                    this.stampIt(dU, idx);
                    this.dispensabeUnits[medRef.reference || ''] = dU;
                    return dU;

                })

            ).subscribe()//.unsubscribe();

        })
    }
    stampIt(dU: string | null, index: number): void {
        const newDuElement = document.createElement('div');
        newDuElement.innerHTML = `<span id="dispensable-units-label"><strong >Dispensable Units:</strong> ${dU || 'N/A'}</span>`;
// $#$        // /* alert(document.querySelector('[data-apiname="quantity"]') */);
        setTimeout(() => {
            //first remve existing ones
            document.querySelectorAll('#dispensable-units-label')[index]?.remove();
            document.querySelectorAll('[data-apiname="quantity"]')[index]?.after(newDuElement);
        }, 0);


    }




    constructor(@Optional() @Inject(MAT_DIALOG_DATA) public data: any) {
        if (!data.groupId) {
// $#$            // /* alert(JSON.stringify(data.medicationReference) */)
            this.medicationCodeableConcept = data.medicationCodeableConcept ? [data.medicationCodeableConcept] : [null];
            this.medicationReference = data.medicationReference ? [data.medicationReference] : [null];
            this.subject = data.subject ? [data.subject] : [null];

            this.groupId = data.groupId;
            this.formFields = [data.formFields];
            this.medicationRequestId = data.medicationRequestId ? [data.medicationRequestId] : [null];
            this.addToSubstitutionArray({
                authorizingPrescription: data.medicationRequestId,
                wasSubstituted: undefined,
                reason: undefined,
                type: undefined
            })
            this.newMedicationCodeableConcept[data.medicationRequestId || ''] = null
            this.newMedicationReference[data.medicationRequestId || ''] = null

        } else {
            // get med.req where groupId == data.groupId
            this.http.get<{ entry: { resource: any }[] }>(`${this.backendEndPoint}/MedicationRequest`).pipe(
                map(res => res.entry?.map(e => e.resource).filter(r => r.groupIdentifier?.value === data.groupId) || [])
            ).subscribe({
                next: (medRequests) => {
                    for (let i = 0; i < medRequests.length; i++) {
                        if (!this.formFields) this.formFields = [];
                        this.formFields.push(this.data.formFields)
                    }
                    this.authorizingRequests = medRequests;
                    this.medicationCodeableConcept = medRequests.map(mr => mr.medicationCodeableConcept || null);
                    this.medicationReference = medRequests.map(mr => mr.medicationReference || null);
                    this.subject = medRequests.map(mr => mr.subject || null);
                    this.groupId = data.groupId;

                    medRequests.forEach((mr, index) => {
                        //FILL relevant frmfield
                        this.formFields[index] = this.formFields[index].map((ff: FormFields): FormFields => {
                            if (ff.generalProperties.fieldApiName === 'medicationCodeableConcept' && mr.medicationCodeableConcept) {
                                ff.generalProperties.value = mr.medicationCodeableConcept;
                                ff.generalProperties.isHidden = true;
                            }
                            if (ff.generalProperties.fieldApiName === 'medicationReference' && mr.medicationReference) {
                                ff.generalProperties.value = mr.medicationReference;
                                ff.generalProperties.isHidden = true;
                            }
                            if (ff.generalProperties.fieldApiName === 'subject' && mr.subject) {
                                ff.generalProperties.value = mr.subject;
                                ff.generalProperties.isHidden = true;

                            }

                            if (ff.generalProperties.fieldApiName === 'authorizingPrescription' && mr.id) {
                                ff.generalProperties.value = [{
                                    reference: `MedicationRequest/${mr.id}`
                                }];
                                ff.generalProperties.isHidden = true;

                            }
                            if (mr.id) {
                                this.addToSubstitutionArray({
                                    authorizingPrescription: mr.id,
                                });
                            }

                            return <FormFields>ff;
                        })

                    });
                },

                error: () => {
                    this.errorService.openandCloseError('Failed to load medication requests for the given group.');
                    // this.dialogRef.close(); 
                }
            });

        }

    }

    private buildFormFields(g: any): FormFields[] {
        return [
            {
                generalProperties: {
                    fieldApiName: 'status',
                    fieldName: 'Status',
                    fieldLabel: 'Status',
                    fieldType: 'SingleCodeField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    value: 'completed',
                    isArray: false,
                    isGroup: false,
                    isHidden: true
                },
                data: ['completed']
            },
            {
                generalProperties: {
                    fieldApiName: 'category',
                    fieldName: 'Dispense Category',
                    fieldLabel: 'Dispense Category',
                    fieldType: 'CodeableConceptField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: false,
                    isGroup: false,
                    allowedOthers: true
                },
                data: g.category
            },
            {
                generalProperties: {
                    fieldApiName: 'medicationReference',
                    fieldName: 'Medication Reference',
                    fieldLabel: 'Medication Reference',
                    fieldType: 'IndividualReferenceField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: false,
                    isGroup: false,
                    isHidden: !g.medicationReference || g.medicationReference.length === 0
                },
                data: g.medicationReference
            },
            {
                generalProperties: {
                    fieldApiName: 'medicationCodeableConcept',
                    fieldName: 'Medication Codeable Concept',
                    fieldLabel: 'Medication Codeable Concept',
                    fieldType: 'CodeableConceptField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: false,
                    isGroup: false
                },
                data: g.medication
            },
            <IndividualField>{
                generalProperties: {
                    fieldApiName: 'quantity',
                    fieldName: 'Quantity Dispensed',
                    fieldLabel: 'Quantity Dispensed',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    inputType: 'number',
                    fieldType: 'IndividualField',
                    isArray: false,
                    isGroup: false
                }
            },
            <IndividualField>{
                generalProperties: {
                    fieldApiName: 'recordedDate',
                    fieldName: 'Recorded Date',
                    fieldLabel: 'Recorded Date',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    inputType: 'datetime-local',
                    value: new Date().toISOString(),
                    isArray: false,
                    isGroup: false,
                    isHidden: true
                }
            },
            <IndividualField>{
                generalProperties: {
                    fieldApiName: 'whenHandedOver',
                    fieldName: 'When Handed Over',
                    fieldLabel: 'When Handed Over',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    inputType: 'datetime-local',
                    isArray: false,
                    isGroup: false
                }
            },
            {
                generalProperties: {
                    fieldApiName: 'subject',
                    fieldName: 'Subject',
                    fieldLabel: 'Who is this Medication For',
                    fieldType: 'CodeableConceptField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: true,
                    isGroup: false
                },
                data: g.subject
            },
            {
                generalProperties: {
                    fieldApiName: 'performerActor',
                    fieldName: 'Performer Actor',
                    fieldLabel: 'Performer Actor',
                    fieldType: 'IndividualReferenceField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: true,
                    isGroup: false
                },
                data: g.performer
            },
            {
                generalProperties: {
                    fieldApiName: 'authorizingPrescription',
                    fieldName: 'Authorizing Prescription',
                    fieldLabel: 'Authorizing Prescription',
                    fieldType: 'IndividualReferenceField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: false,
                    isGroup: false
                },
                data: g.authorizingPrescription
            },
            {
                generalProperties: {
                    fieldApiName: 'receiver',
                    fieldName: 'Receiver',
                    fieldLabel: 'Receiver',
                    fieldType: 'IndividualReferenceField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: true,
                    isGroup: false
                },
                data: g.subject
            },
            <IndividualField>{
                generalProperties: {
                    fieldApiName: 'dosageInstruction',
                    fieldName: 'Dosage Instructions',
                    fieldLabel: 'Dosage Instructions',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    inputType: 'textarea',
                    isArray: false,
                    isGroup: false
                }
            },
            {
                generalProperties: {
                    fieldApiName: 'substitution',
                    fieldName: 'Substitution Info',
                    fieldLabel: 'Substitution Info',
                    fieldType: 'CodeField',
                    auth: { read: 'all', write: 'doctor, nurse' },
                    isArray: false,
                    isGroup: true
                },
                keys: ['wasSubstituted', 'substitutionReason', 'substitutionType'],
                groupFields: {
                    wasSubstituted: {
                        generalProperties: {
                            fieldApiName: 'substitution_wasSubstituted',
                            fieldName: 'Was Substituted',
                            fieldLabel: 'Was Substituted',
                            fieldType: 'SingleCodeField',
                            inputType: 'toggle',
                            auth: { read: 'all', write: 'doctor, nurse' },
                            isArray: false,
                            isGroup: false
                        },
                        data: ['Yes', 'No']
                    },
                    substitutionReason: {
                        generalProperties: {
                            fieldApiName: 'substitution_reason',
                            fieldName: 'Substitution Reason',
                            fieldLabel: 'Substitution Reason',
                            fieldType: 'CodeableConceptField',
                            allowedOthers: true,
                            auth: { read: 'all', write: 'doctor, nurse' },
                            isArray: false,
                            isGroup: false
                        },
                        data: g.substitutionReason
                    },
                    substitutionType: {
                        generalProperties: {
                            fieldApiName: 'substitution_type',
                            fieldName: 'Substitution Type',
                            fieldLabel: 'Substitution Type',
                            fieldType: 'CodeableConceptField',
                            allowedOthers: true,
                            auth: { read: 'all', write: 'doctor, nurse' },
                            isArray: false,
                            isGroup: false
                        },
                        data: g.substitutionType
                    }
                }
            }
        ];
    }

    onSubmit(values: any) {

        if (!values) return;
        const quantity = this.parseQuantity(values.quantity);
        const medRef = this.coerceReference(values.medicationReference);
        this.prepareBundle(values, quantity, medRef).subscribe({
            next: (entries) => this.postBundle(entries),
            error: () => this.errorService.openandCloseError('Failed to prepare dispense payload.')
        });
    }

    private prepareBundle(entry: any, quantity: number, medRef?: { reference: string }) {
        if (medRef?.reference && quantity > 0) {
            const medId = this.extractResourceId(medRef.reference);
            if (!medId) return of(this.buildEntries(entry, quantity, medRef));
            return this.http.get<Medication>(`${this.backendEndPoint}/Medication/${medId}`).pipe(
                map(medication => this.buildEntries(entry, quantity, medRef, medication, medId))
            );
        }
        return of(this.buildEntries(entry, quantity, medRef));
    }

    private buildEntries(entry: any, quantity: number, medRef?: { reference: string }, medication?: Medication, medId?: string) {
        const dispense = this.buildMedicationDispenseResource(entry, quantity, medRef);
        const entries: any[] = [];
        if (medication && medId) {
            const updated = this.buildMedicationUpdatePayload(medication, quantity);
            if (updated) {
                entries.push({
                    resource: { ...updated, resourceType: 'Medication', id: medId },
                    request: { method: 'PUT', url: `Medication/${medId}` }
                });
            }
        }
        entries.push({
            resource: dispense,
            request: { method: 'POST', url: 'MedicationDispense' }
        });
        return entries;
    }
    stateService = inject(StateService);
    private postBundle(entries: any[]) {
        const bundle: { resourceType: 'Bundle', type: 'transaction', entry: any[] } = { resourceType: 'Bundle', type: 'transaction', entry: entries };
        this.fhirResourceService.postBundle(bundle).subscribe({
            next: ({ bundle }) => {
                console.log(bundle);
                this.stateService.processOrgWideBundleTransaction(bundle);
                this.snackBar.openFromComponent(SuccessMessageComponent, {
                    data: { message: 'Medication dispense saved successfully.' },
                    duration: 3000
                });
                this.dialogRef.close();
                
                // ✅ Post alerts to prescribing doctors
                const orgId = this.auth.user.getValue()?.organizationId || this.auth.user.getValue()?.hospitalId;
                if (orgId && this.authorizingRequests.length) {
                    const patientName = this.stateService.PatientResources.currentPatient.getValue()?.actualResource?.name?.[0]?.text || 'Patient';
                    const patientId = this.stateService.currentPatientId$.getValue();

                    this.authorizingRequests.forEach(mr => {
                        const requesterRef = mr.requester?.reference;
                        if (requesterRef && requesterRef.includes('Practitioner/')) {
                            const requesterId = requesterRef.split('/')[1];
                            const medDisplay = mr.medicationReference?.display || mr.medicationCodeableConcept?.text || 'Medication';
                            
                            const alertPayload: any = {
                                title: 'Medication Dispensed',
                                description: `${medDisplay} has been dispensed for ${patientName}`,
                                url: `/patient-wrapper/${patientId}/medications`
                            };
                            if (mr?.id) alertPayload.query = { resourceId: mr.id };
                            this.firebaseAlertService.postUserAlert(orgId, requesterId, alertPayload).subscribe();
                        }
                    });
                }
            },
            error: () => this.errorService.openandCloseError('Failed to submit dispense bundle.')
        });
    }

    private buildMedicationDispenseResource(entry: any, quantity: number, medicationReference?: { reference: string; display?: string }, unit?: string) {
        const resource: any = {
            status: 'in-progress',
            whenHandedOver: entry.whenHandedOver ?? new Date().toISOString(),
            quantity: {
                value: Number.isFinite(quantity) ? quantity : 0,
                ...(unit ? { unit, system: 'http://unitsofmeasure.org' } : {})
            }
        };
        if (medicationReference?.reference) {
            resource.medicationReference = medicationReference;
        } else if (entry?.medicationCodeableConcept) {
            resource.medicationCodeableConcept = entry.medicationCodeableConcept;
        }
        const subjectRef = this.coerceReference(entry?.subject);
        if (subjectRef?.reference) {
            resource.subject = subjectRef;
        }
        const performerRef = this.coerceReference(entry?.performerActor);
        if (performerRef?.reference) {
            resource.performer = [{ actor: performerRef }];
        }
        if (entry?.status) {
            resource.status = (entry.status || '').toString().toLowerCase();
        }
        return resource;
    }

    private buildMedicationUpdatePayload(medication: Medication, quantity: number): Medication | undefined {
        const totalRemainingExt = this.findInventoryExtension(medication);
        // const totalRemainingExt = this.findInventoryField(inventory, 'totalRemaining');
        if (!totalRemainingExt) return undefined;
        const cloned = JSON.parse(JSON.stringify(medication));
        const clonedField = this.findInventoryExtension(cloned);
        // const clonedField = this.findInventoryField(clonedInventory, 'totalRemaining');
        console.log('clonedField', clonedField);
        console.log('totalRemainingExt', totalRemainingExt);
        if (!clonedField) return undefined;
        const current = Number(totalRemainingExt.valueQuantity?.value ?? totalRemainingExt.valueInteger ?? totalRemainingExt.valueString ?? 0);
        const updatedValue = Math.max(0, current - quantity);
        //quntity, updatedVal
        console.log('current', current, 'updatedValue', updatedValue);
        if (clonedField.valueQuantity) {
            clonedField.valueQuantity.value = updatedValue;
        } else {
            clonedField.valueInteger = updatedValue;
        }
        cloned.extension.map((ext: any) => {
            if (ext.url === clonedField.url) {
                return clonedField;
            }
        });
        console.log(cloned);
        return cloned;
    }

    private findInventoryExtension(medication: Medication): any | undefined {
        return medication?.extension?.find((ext: any) =>
            typeof ext.url === 'string' && ext.url.endsWith('totalRemaining')
        );
    }

    private findInventoryField(inventory: any, key: string): any | undefined {
        return inventory?.extension?.find((ext: any) =>
            ext?.url === key || (typeof ext?.url === 'string' && ext.url.endsWith(`/${key}`))
        );
    }

    private getInventoryUnit(medication: any): string | undefined {
        return medication?.extension?.find((ext: any) =>
            typeof ext.url === 'string' && ext.url.endsWith('dispensableUnits')
        )?.valueString;
        // return unitExt.valueString || unitExt.valueCodeableConcept?.text || unitExt.valueCodeableConcept?.coding?.[0]?.display;
    }

    private coerceReference(input: any): { reference: string; display?: string } | undefined {
        if (!input) return undefined;
        if (typeof input === 'string') {
            const parts = input.split('$#$').map(p => p.trim());
            return { reference: `${parts[0]}`.trim(), display: parts[1]?.trim() };
        }
        if (typeof input === 'object' && input.reference) {
            return { reference: input.reference, display: input.display };
        }
        return undefined;
    }

    private parseQuantity(value: any): number {
        if (value == null) return 0;
        const numeric = typeof value === 'object' && 'value' in value ? Number(value.value) : Number(value);
        return Number.isFinite(numeric) ? numeric : 0;
    }

    private extractResourceId(reference?: string): string | undefined {
        if (!reference) return undefined;
        const parts = reference.split('/');
        return parts.length ? parts[parts.length - 1] : undefined;
    }

    submitCombinedDispenseBundle() {
        this.putTogether();
        const entries = this.combinedResource?.filter(Boolean) ?? [];
        if (!entries.length) {
            this.errorService.openandCloseError('No dispense data is available.');
            return;
        }

        const validationError = this.validateDispenseEntries(entries);
        if (validationError) {
            this.errorService.openandCloseError(validationError);
            return;
        }

        const payloads = entries.map((entry) => this.prepareDispensePayloadEntry(entry));
        forkJoin(payloads)
            .pipe(
                map((items) =>
                    items.flatMap((item: any) => {
                        const bundleEntries: any[] = [];

                        if (item.medicationUpdate) {
                            bundleEntries.push({
                                resource: {
                                    ...item.medicationUpdate.resource,
                                    resourceType: 'Medication',
                                    id: item.medicationUpdate.id
                                },
                                request: { method: 'PUT', url: `Medication/${item.medicationUpdate.id}` }
                            });
                        }

                        if (item.dispenseResource) {
                            bundleEntries.push({
                                resource: {
                                    ...item.dispenseResource,
                                    resourceType: 'MedicationDispense'
                                },
                                fullUrl: item.medicationDispenseFullUrl,
                                request: { method: 'POST', url: 'MedicationDispense' }
                            });
                        }

                        // ✅ NEW: billing resources
                        if (item.chargeItemResource) {
                            bundleEntries.push({
                                fullUrl: item.chargeItemFullUrl,
                                resource: { ...item.chargeItemResource, resourceType: 'ChargeItem' } as ChargeItem,
                                request: { method: 'POST', url: 'ChargeItem' }
                            });
                        }

                        if (item.invoiceResource) {
                            bundleEntries.push({
                                resource: { ...item.invoiceResource, resourceType: 'Invoice' } as Invoice,
                                request: { method: 'POST', url: 'Invoice' }
                            });
                        }

                        return bundleEntries;
                    })
                ),
                switchMap((bundleEntries: any[]) => {
                    if (!bundleEntries.length) {
                        this.errorService.openandCloseError('Failed to build dispense bundle.');
                        return of(null);
                    }
                    return this.fhirResourceService.postBundle({ resourceType: 'Bundle', type: 'transaction', entry: bundleEntries });
                })
            )
            .subscribe({
                next: (result: any) => {
                    if (!result) return;
                    console.log(result.bundle);
                    this.stateService.processOrgWideBundleTransaction(result.bundle);
                    this.snackBar.openFromComponent(SuccessMessageComponent, {
                        data: { message: 'Medication dispense saved successfully.' },
                        duration: 3000
                    });
                    this.dialogRef.close(true);
                },
                error: (err) => {
                    console.error('[meddispense] preparation failed', err);
                    this.errorService.openandCloseError(err?.message || 'Failed to submit dispense bundle.');
                }
            });
    }

    private validateDispenseEntries(entries: any[]): string | null {
        // for (const entry of entries) {
// $#$        // /* alert(JSON.stringify(entry) */)
        let validationError = '';
        entries.forEach((entry: any, index: number) => {
            const quantity = this.parseQuantity(entry?.quantity);
            const medicationReference = this.coerceReference(entry?.medicationReference);
            if (!medicationReference?.reference) {
                validationError += 'Each dispense requires a medication reference.';
            }
            if (!Number.isFinite(quantity) || quantity <= 0) {
                validationError += 'A valid quantity is required for every dispense.';
            }
            if ((this.medRequestDosageText[index] === '' || !this.medRequestDosageText[index])
                && (!entry?.dosageInstruction || entry?.dosageInstruction?.length === 0)
                && (!this.medRequestDosageJson)) {
                validationError += 'Dosage instruction is required fr dispense if it\'s nt avaiabe in the request';
            }



        });
        if (validationError) {
            return validationError;
        }
        return null;
    }
    authService = inject(AuthService);

    private prepareDispensePayloadEntry(entry: any) {
        const quantity = this.parseQuantity(entry?.quantity);
        const medRef = this.coerceReference(entry?.medicationReference);
        const medId = this.extractResourceId(medRef?.reference);

        if (!medRef?.reference) {
            throw new Error('Missing medication reference for dispense entry.');
        }

        // Helper: create ChargeItem + Invoice from ChargeItemDefinition
        const buildBillingResources = (def: ChargeItemDefinition | null | undefined) => {
            // if (!def) return { chargeItemResource: undefined, invoiceResource: undefined };

            const nowIso = new Date().toISOString();

            // Transaction-local references using fullUrl urn uuids
            const chargeItemFullUrl = `urn:uuid:${crypto.randomUUID()}`;
            const invoiceFullUrl = `urn:uuid:${crypto.randomUUID()}`;
            const medicationDispenseFullUrl = `urn:uuid:${crypto.randomUUID()}`;

            const subjectRef = this.coerceReference(entry?.subject);

            const quantityNum = Number.isFinite(quantity) && quantity > 0 ? quantity : 1;

            // ---- pricing helpers (mirrors MedicationComponent2.seperateTotalPriceComponents) ----
            const priceComponents = (def as any)?.propertyGroup?.[0]?.priceComponent ?? [];
            const asNumber = (v: any) => (v === undefined || v === null || v === '' ? 0 : Number(v));
            const money = (value: number, currency?: string) => ({
                value,
                currency: (currency || (def as any)?.propertyGroup?.[0]?.priceComponent?.[0]?.amount?.currency || 'NGN')
            });

            const componentTotals: Record<string, number> = {
                base: 0,
                surcharge: 0,
                tax: 0,
                deduction: 0,
                discount: 0,
                informational: 0
            };

            const currency =
                (def as any)?.propertyGroup?.[0]?.priceComponent?.find((pc: any) => pc?.amount?.currency)?.amount?.currency ||
                (def as any)?.propertyGroup?.[0]?.priceComponent?.[0]?.amount?.currency ||
                'NGN';

            // Aggregate amounts by type, then scale by quantity
            (Array.isArray(priceComponents) ? priceComponents : []).forEach((pc: any) => {
                const t = (pc?.type ?? '').toString();
                const amt = asNumber(pc?.amount?.value) * quantityNum;
                if (!t) return;
                if (componentTotals[t] === undefined) componentTotals[t] = 0;
                componentTotals[t] += amt;
            });

            // Net excludes deduction/discount; Gross includes them
            const totalNetValue =
                (componentTotals['base'] || 0) +
                (componentTotals['surcharge'] || 0) -
                (componentTotals['deduction'] || 0) -
                (componentTotals['discount'] || 0);


            const totalGrossValue =
                totalNetValue + (componentTotals['tax'] || 0);

            // Convert aggregated totals to Invoice.totalPriceComponent[]
            const totalPriceComponent = (['base', 'surcharge', 'tax', 'deduction', 'discount', 'informational'] as const)
                .map((t) => {
                    const v = componentTotals[t] || 0;
                    if (!Number.isFinite(v) || v === 0) return null;
                    return {
                        type: t,
                        amount: money(v, currency)
                        // NOTE: you can optionally carry factor/code/extensions from def,
                        // but here we keep it minimal + consistent with your UI totals.
                    };
                })
                .filter(Boolean) as any[];

            // LineItem.priceComponent[] (use def components but scaled by quantity for this dispense)
            const lineItemPriceComponent = (Array.isArray(priceComponents) ? priceComponents : [])
                .map((pc: any) => {
                    const value = asNumber(pc?.amount?.value) * quantityNum;
                    if (!Number.isFinite(value) || value === 0) return null;
                    return {
                        // keep same type as definition (base/discount/etc)
                        type: pc?.type,
                        code: pc?.code,
                        factor: pc?.factor,
                        amount: money(value, currency)
                    };
                })
                .filter(Boolean);

            // ---- ChargeItem + Invoice resources ----
            const organizationId = this.authService.getOrganizationId();

            const chargeItemResource: ChargeItem = {
                resourceType: 'ChargeItem',
                status: 'billed',
                ...(def ? { definitionCanonical: [`${this.backendEndPoint}/ChargeItemDefinition/${def.id}`] } : {}),
                identifier: [this.utilityService.buildIdentifier({
                    system: `${this.backendEndPoint}/ChargeItem/identifier`,
                    resourceType: 'ChargeItem',
                    typeCoding: {
                        code: 'MED-DISP',
                        system: `${this.backendEndPoint}`,
                        display: 'Medication Dispense Charge'
                    },
                    assigner: {
                        reference: 'E-Likita',
                        display: 'E-Likita Health'
                    }

                })],
                ...(medId ? {
                    productReference: {
                        reference: `Medication/${medId}`
                    }
                } : {}),
                service: [{
                    reference: medicationDispenseFullUrl
                }],
                code: {
                    coding: [
                        {
                            code: 'MED-DISP',
                            system: `${this.backendEndPoint}`,
                            display: 'Medication Dispense Charge'
                        },

                    ],
                    text: 'Medication Dispense Charge'

                },
                ...({ subject: { reference: subjectRef!.reference } }),
                quantity: Number.isFinite(quantity) && quantity > 0 ? { value: quantity } : undefined,
                occurrenceDateTime: nowIso,
                ...(entry.authorizingPrescription?.length
                    && this.medRequestEncounters[entry.authorizingPrescription[0].reference]
                    ? {
                        context: this.medRequestEncounters[entry.authorizingPrescription[0].reference]
                    } : {}),
                ...(organizationId ? { performingOrganization: { reference: `Organization/${organizationId}` } } : {}),
                // link back for traceability
                // definitionUri: Array.isArray((def as any)?.url) ? (def as any)?.url?.[0] : (def as any)?.url
            };

            const invoiceResource: Invoice = {
                resourceType: 'Invoice',
                status: 'issued',
                subject: subjectRef?.reference ? { reference: subjectRef.reference, display: subjectRef.display } : undefined,
                date: nowIso,
                identifier: [this.utilityService.buildIdentifier({
                    system: `${this.backendEndPoint}/Invoice/identifier`,
                    resourceType: 'Invoice',
                    typeCoding: {
                        code: 'MED-DISP-INVOICE',
                        system: `${this.backendEndPoint}`,
                        display: 'Medication Dispense Invoice'
                    },
                    assigner: {
                        reference: 'E-Likita',
                        display: 'E-Likita Health'
                    }

                })],
                issuer: {
                    reference: `Organization/${this.authService.getOrganizationId()}`,
                },
                lineItem: [
                    {
                        sequence: 1,
                        chargeItemReference: { reference: chargeItemFullUrl },
                        ...(lineItemPriceComponent?.length ? { priceComponent: lineItemPriceComponent as any } : {})
                    } as any
                ],
                ...(totalPriceComponent?.length ? { totalPriceComponent: totalPriceComponent as any } : {}),
                ...(Number.isFinite(totalNetValue) && def ? { totalNet: money(Math.max(0, totalNetValue), currency) as any } : {}),
                ...(Number.isFinite(totalGrossValue) && def ? { totalGross: money(Math.max(0, totalGrossValue), currency) as any } : {})
            };

            // return both + their fullUrls so caller can include fullUrl in entries
            return { chargeItemResource: { ...chargeItemResource, id: undefined } as any, invoiceResource: { ...invoiceResource, id: undefined } as any, chargeItemFullUrl, invoiceFullUrl, medicationDispenseFullUrl };
        };

        if (!medId) {
            const dispenseResource = this.buildMedicationDispenseResource(entry, quantity, medRef);

            // Try to bill even without medId? we can't match ChargeItemDefinition reliably -> skip.
            return of({ dispenseResource });
        }

        // ✅ Fetch Medication + ChargeItemDefinition in parallel
        const medication$ = this.http.get<Medication>(`${this.backendEndPoint}/Medication/${medId}`,
            // {
            // headers: { 'Cache-Control': 'no-cache', Pragma: 'no-cache' }
            // }
        );

        // Conservative matching rule: ChargeItemDefinition?product=Medication/{id}
        // Adjust to your server's actual parametrization if different.
        const chargeItemDef$ = this.http
            .get<any>(`${this.backendEndPoint}/ChargeItemDefinition?instance=Medication/${medId}`)
            .pipe(
                map((bundle: any) => { console.log(bundle); return (bundle?.entry?.find((e: BundleEntry<ChargeItemDefinition>) => e.resource?.instance?.some((ins) => { return ins.reference === `Medication/${medId}` }) && e.resource.status === 'active')?.resource as ChargeItemDefinition) ?? null }),

                // If server doesn't support, just continue without billing
                // (avoid adding catchError import by using inline try in map chain isn't possible; simplest: rely on outer subscribe error handling)
            );

        return forkJoin({ medication: medication$, chargeItemDef: chargeItemDef$ }).pipe(
            map(({ medication, chargeItemDef }) => {
                const totalRemaining = this.findInventoryExtension(medication);
                // const totalRemaining = this.findInventoryField(inventory, 'totalRemaining');
                console.log('[meddispense] found inventory', totalRemaining);
                const remaining = Number(
                    totalRemaining?.valueQuantity?.value ??
                    totalRemaining?.valueInteger ??
                    totalRemaining?.valueString ??
                    NaN
                );
                if (Number.isFinite(remaining) && quantity > remaining) {
                    throw new Error(`Requested quantity exceeds available stock which is ${remaining}.`);
                }
                if (quantity <= 0) {
                    throw new Error('Requested quantity must be greater than zero.');
                }

                const medicationUpdate = this.buildMedicationUpdatePayload(medication, quantity);
                const unit = this.getInventoryUnit(medication);

                // const dispenseResource = this.buildMedicationDispenseResource(entry, quantity, medRef, unit);
                return {
                    dispenseResource: { ...entry, quantity: { ...entry.quantity, unit: unit ?? 'pieces' }, status: 'in-progress' },
                    ...buildBillingResources(chargeItemDef),
                    // medicationUpdate: medicationUpdate ? { id: medId, resource: medicationUpdate } : undefined
                };
            })
        );
    }



    // ✅ Used by add-medication-dispense.component.html
    medRequestDosageJson: (Dosage[] | null)[] = [null];
    medRequestDosageText: string[] = [''];
    // ...existing code...

    // ✅ Pull dosageInstruction from the MedicationRequest row if provided



    // ...existing code...


    // ✅ Used by add-medication-dispense.component.html
    openMedicationRequestDosageDialog(i: number): void {
        if (!this.medRequestDosageJson?.[i]?.length) {
            this.errorService.openandCloseError('No dosage instruction found on this MedicationRequest.');
            return;
        }

        this.dialog.open(MedRequestDosageDialogComponent, {
            width: '720px',
            maxHeight: '90vh',
            data: {
                text: this.medRequestDosageText[i],
                json: this.medRequestDosageJson[i]
            }
        });
    }

    private formatMedicationRequestDosage(dosage: Dosage[]): string {
        const clean = (v: any) => (v === undefined || v === null ? '' : String(v).trim());
        const unitToNice = (u: any) => this.utilityService.durationUnitToNiceDisplay(clean(u)) || clean(u);

        const fmtTiming = (d: any): string => {
            const repeat = d?.timing?.repeat ?? {};
            const freq = repeat?.frequency;
            const period = repeat?.period;
            const periodUnit = unitToNice(repeat?.periodUnit);

            const timingCode =
                clean(d?.timing?.code?.text) ||
                clean(d?.timing?.code?.coding?.[0]?.display) ||
                clean(d?.timing?.code?.coding?.[0]?.code);

            const freqPart =
                freq != null && period != null
                    ? `${freq} time(s) every ${period}${periodUnit ? ` ${periodUnit}` : ''}`.trim()
                    : '';

            return [freqPart, timingCode].filter(Boolean).join(' | ');
        };

        const fmtDuration = (d: any): string => {
            const repeat = d?.timing?.repeat ?? {};
            const duration = repeat?.duration;
            const durationUnit = unitToNice(repeat?.durationUnit);
            if (duration == null && !durationUnit) return '';
            return `${clean(duration)} ${clean(durationUnit)}`.trim();
        };

        const fmtDose = (d: any): string => {
            const dq = d?.doseAndRate?.[0]?.doseQuantity;
            const value = dq?.value;
            const unit = dq?.unit || dq?.code;
            if (value == null && !unit) return '';
            return `${clean(value)} ${clean(unit)}`.trim();
        };

        return dosage
            .map((d: any, i: number) => {
                const parts = [
                    clean(d?.text),
                    fmtTiming(d),
                    fmtDuration(d) ? `Duration: ${fmtDuration(d)}` : '',
                    fmtDose(d) ? `Dose: ${fmtDose(d)}` : ''
                ].filter(Boolean);
                return `#${i + 1}: ${parts.join(' • ')}`;
            })
            .join('\n');
    }





}

// ✅ Minimal standalone dialog used by openMedicationRequestDosageDialog()
@Component({
    selector: 'app-medrequest-dosage-dialog',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule, MatCardModule, MatExpansionModule],
    template: `
    <div style="display:flex; align-items:flex-start; justify-content:space-between; gap: 12px;"
    class="p-20"
    >
      <div>
        <h2 mat-dialog-title style="margin: 0;">Dosage Instructions</h2>
        <div style="margin-top: 2px; color: var(--mat-sys-on-surface-variant); font-size: 0.9rem;">
          From the original MedicationRequest
        </div>
      </div>

      <button mat-icon-button mat-dialog-close aria-label="Close dialog">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div mat-dialog-content style="padding-top: 12px;">
      <mat-card appearance="outlined" style="border-color: var(--mat-sys-outline-variant);">
        <mat-card-header>
          <mat-card-title style="font-size: 1rem;">Readable summary</mat-card-title>
          <mat-card-subtitle>Use this to confirm what should be dispensed</mat-card-subtitle>
        </mat-card-header>

        <mat-card-content>
          @if(data?.text){
            <pre style="
              white-space: pre-wrap;
              word-break: break-word;
              margin: 0;
              padding: 10px 12px;
              border-radius: 8px;
              background: var(--mat-sys-surface-container-low);
              color: var(--mat-sys-on-surface);
              border: 1px solid var(--mat-sys-outline-variant);
              font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
              font-size: 0.92rem;
              line-height: 1.4;
            ">{{ data.text }}</pre>
          } @else {
            <div style="
              padding: 12px;
              border-radius: 8px;
              background: var(--mat-sys-surface-container-low);
              border: 1px dashed var(--mat-sys-outline-variant);
              color: var(--mat-sys-on-surface-variant);
            ">
              No dosage instruction text was provided on this MedicationRequest.
            </div>
          }
        </mat-card-content>
      </mat-card>

      <div style="height: 12px;"></div>

      <mat-accordion>
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>Raw JSON (for troubleshooting)</mat-panel-title>
            <mat-panel-description>
              Show the exact FHIR dosageInstruction array
            </mat-panel-description>
          </mat-expansion-panel-header>

          <pre style="
            white-space: pre-wrap;
            word-break: break-word;
            margin: 0;
            padding: 10px 12px;
            border-radius: 8px;
            background: var(--mat-sys-surface-container);
            border: 1px solid var(--mat-sys-outline-variant);
            color: var(--mat-sys-on-surface);
            font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, 'Liberation Mono', 'Courier New', monospace;
            font-size: 0.85rem;
            line-height: 1.35;
          ">{{ data?.json | json }}</pre>
        </mat-expansion-panel>
      </mat-accordion>
    </div>

    <div mat-dialog-actions align="end">
      <button mat-stroked-button mat-dialog-close>Close</button>
    </div>
  `
})
export class MedRequestDosageDialogComponent {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { text?: string; json?: any }) { }
}
